import { Estabelecimento } from "../estabelecimentos/estabelecimento";

export class Usuario{
	IdUsuario:number;
	Login:string;
    Nome:string;
    PrimeiroNome:string;
    Telefone:string;
    Ativo:boolean;
    TipoUsuario:string;
    Email: string;

    Estabelecimentos: Array<Estabelecimento>;
}


// WEBPACK FOOTER //
// ./src/app/pages/usuarios/usuario.model.ts